<template>
  <div class="modal fade" id="createAccountGroupModal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 v-if="!editing" class="modal-title">New Group</h5>
          <h5 v-if="editing" class="modal-title">Edit Group</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="saveAccountGroup">
            <div class="form-group">
              <label for="name">Group Name</label>
              <input
                type="text"
                class="form-control"
                id="name"
                placeholder="Group Name"
                required
                v-model="newName"
              />
            </div>
            <div class="form-group">
              <label for="description">Description</label>
              <input
                type="text"
                class="form-control"
                id="description"
                placeholder="Description"
                required
                v-model="newDescription"
              />
            </div>

            <div class="text-right">
              <button v-if="editing" class="btn btn-primary">
                Update Group
              </button>
              <button v-if="!editing" type="submit" class="btn btn-primary">
                Create Group
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "CreateAccountGroupModal",
  props: {
    AccountGroup: Object
  },
  data() {
    return {
      newName: "",
      newDescription: "",
      editingAccountGroup: null,
      editing: false
    };
  },
  watch: {
    AccountGroup: function() {
      if (this.AccountGroup != null) {
        this.newName = this.AccountGroup.Name;
        this.newDescription = this.AccountGroup.Description;
        this.editingAccountGroup = this.AccountGroup;
        this.editing = true;
      } else {
        this.clearFields();
        this.editing = false;
      }
    }
  },
  mounted() {
    var view = this;
    $("#createAccountGroupModal").on("hidden.bs.modal", function() {
      if (view.editing) {
        view.$emit("editClosed");
      }
    });
    $("#createAccountGroupModal").on("shown.bs.modal", function() {
      $("#name").focus();
    });
  },
  methods: {
    async saveAccountGroup() {
      if (this.editing) {
        await this.editAccountGroup();
      } else {
        await this.createAccountGroup();
      }
    },
    async createAccountGroup() {
      var view = this;
      $("#createAccountGroupModal").modal("hide");
      view.$store.commit("updateLoading", true);
      var accountGroupToCreate = {
        Name: view.$data.newName,
        Description: view.$data.newDescription,
        Accounts: []
      };
      await this.$createAccountGroup(accountGroupToCreate)
        .then(newGroup => {
          view.$emit("addedAccountGroup", newGroup);
          view.$store.commit("updateLoading", false);
          view.clearFields();
        })
        .catch(e => {
          console.log(e);
          view.$store.commit("updateLoading", false);
        });
    },
    async editAccountGroup() {
      var view = this;
      $("#createAccountGroupModal").modal("hide");
      view.$store.commit("updateLoading", true);
      var accountGroupToUpdate = {
        AccountGroup_Id: view.$data.editingAccountGroup.AccountGroup_Id,
        Name: view.$data.newName,
        Description: view.$data.newDescription,
        Accounts: view.$data.editingAccountGroup.Accounts
      };
      await this.$updateAccountGroup(accountGroupToUpdate)
        .then(editedAccountGroup => {
          view.$emit("editedAccountGroup", editedAccountGroup);
          view.$store.commit("updateLoading", false);
          view.clearFields();
        })
        .catch(e => {
          console.log(e);
          view.$store.commit("updateLoading", false);
        });
    },
    clearFields() {
      this.newName = "";
      this.newDescription = "";
      this.editingAccountGroup = null;
    }
  }
};
</script>
